import axios from 'axios'

export const state = {
  cached: [],
}

export const getters = {}

export const mutations = {
  CACHE_PATIENT(state, newPatient) {
    state.cached.push(newPatient)
  },
}

export const actions = {
  fetchPatient({ commit, state, rootState }, { id }) {
    // 1. Check if we've already fetched and cached the patient.
    const matchedPatient = state.cached.find(
      (patient) => patient.patient_id === id
    )
    if (matchedPatient) {
      return Promise.resolve(matchedPatient)
    }

    // 2. Fetch the patient from the API and cache it in case
    //    we need it again in the future.
    return axios.get(`/api/v1/patients/${id}`).then((response) => {
      const patient = response.data
      commit('CACHE_PATIENT', patient)
      return patient
    })
  },
}
